import _assert_this_initialized from "@swc/helpers/src/_assert_this_initialized.mjs";
import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _create_class from "@swc/helpers/src/_create_class.mjs";
import _define_property from "@swc/helpers/src/_define_property.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import regeneratorRuntime from "/builds/lululemon/global-digital-tech/content-and-education/ecom-web-app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import PropTypes from "prop-types";
import qs from "query-string";
import Cookies from "js-cookie";
import { getRouteManifest } from "next-known-route";
import { init as initSentry, makeMultiplexedTransport, makeFetchTransport, BrowserTracing } from "@sentry/browser";
import url from "url";
import { convertToUnderscored, convertToDashed } from "@lululemon/mwa-i18n";
import { NavDataProvider } from "@lululemon/meganav";
import { digitalData } from "@lululemon/ecom-core";
import Router from "next/router";
import { set } from "@lululemon/mwa-ab-testing/esm/utils/storage";
import { ABFlagsProvider } from "@lululemon/mwa-ab-testing/esm";
import { publicConfig } from "@lululemon/ecom-common/src/util/public-config";
import { compose, log } from "@lululemon/mwa-utils";
import { initializeMwaLaunchDarkly } from "./util/mwa-ld.js";
import Layout from "@lululemon/ecom-common/src/components/layout";
import { mergeQueryParams } from "@lululemon/ecom-common/src/util/helpers";
import withReduxStore from "@lululemon/ecom-common/src/store/with-redux-store";
import { loadDigitalData } from "@lululemon/ecom-common/src/lib/digital-data";
import { analyticsDataLayerLoaded } from "@lululemon/ecom-common/src/store/actions/page-data-actions";
import { toggleFlag } from "@lululemon/ecom-common/src/store/actions/ab-flags";
import { setHydrated } from "@lululemon/ecom-common/src/util/is-hydrated";
import { doesMatchRoute } from "@lululemon/ecom-common/src/lib/link-generator";
import EcomWebAppJotaiProvider from "@lululemon/ecom-common/src/jotai/ecom-web-app-jotai-provider.js";
import { multiplexerRouter } from "@lululemon/mwa-logger";
import { isUserLoggedIn } from "@lululemon/mwa-auth";
import { withHeaderFlags } from "@lululemon/mwa-header-flags";
import "@lululemon/ecom-common/src/style/index.scss";
import "@lululemon/ui-foundations/styles/base.scss";
import { withLapel } from "@lululemon/ecom-personalization";
import { clearAppliedFilter } from "@lululemon/ecom-common/src/lib/analytics";
import { AnalyticsProvider } from "@lululemon/ecom-analytics";
import withWeather from "@lululemon/ecom-personalization/src/hocs/weather/withWeather";
import { withLocale, withUrqlClient, withWrappedFetch, withCommitHash, withDigitalData } from "./util/new-data-composition";
import withDeviceCharacteristics from "./util/with-device-characteristics";
import { ToastProvider as ToastProviderV6 } from "@lululemon/ecom-pattern-library-toast";
import { ToastProvider } from "@lululemon/ui-library";
import { withHydrationOverlay } from "./util/with-hydration-overlay.js";
import { withLaunchDarkly } from "./util/with-launchdarkly.js";
import withCdpSeoDataService from "./util/with-cdp-seo-data-service.js";
import { beforeSendTransaction, sanitizeTransactionName } from "./util/tracing";
import { initializeV3RolloutFlags } from "./util/with-v3-rollouts";
import { initializePCMRolloutFlags } from "./util/with-pcm-rollout-manager.js";
var ref;
if (process.browser) {
    require("focus-visible");
    require("focus-within-polyfill");
}
var setGlobalFlagAPI = function(store) {
    var _loop = function(key) {
        if (flagCookies.hasOwnProperty(key)) {
            var value = flagCookies[key];
            document.addEventListener("".concat(value, "Set"), function() {
                var lateIsEnabled = Cookies.get(value, {
                    path: "/"
                }) === "true";
                store.dispatch(toggleFlag({
                    name: key,
                    isEnabled: lateIsEnabled
                }));
            });
            var isEnabled = Cookies.get(value, {
                path: "/"
            }) === "true";
            store.dispatch(toggleFlag({
                name: key,
                isEnabled: isEnabled
            }));
        }
    };
    var flagCookies = {
        pdpInseamV2: "pdpInseamV2",
        pdpGoesWellWith: "pdpGoesWellWith",
        pdpAlsoAvailableIn: "pdpAlsoAvailableIn",
        pdpDesktopGoeswellwith: "pdpDesktopGoeswellwith"
    };
    for(var key in flagCookies)_loop(key);
    window.toggleFlag = function(name, isEnabled) {
        store.dispatch(toggleFlag({
            name: name,
            isEnabled: isEnabled
        }));
        Cookies.set(flagCookies[name], isEnabled, {
            path: "/"
        });
    };
    window.setABFlag = function(flag, value) {
        set(flag, value, {});
    };
};
initializeMwaLaunchDarkly();
initializeV3RolloutFlags();
// PCMRollout | January - May 2025 | Contact @ausanin, @ericcatlin
initializePCMRolloutFlags({
    clientId: publicConfig === null || publicConfig === void 0 ? void 0 : (ref = publicConfig.launchDarkly) === null || ref === void 0 ? void 0 : ref.clientSideId
});
var _Component;
var DARAppShell = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(DARAppShell, _superClass);
    var _super = _create_super(DARAppShell);
    function DARAppShell(props) {
        _class_call_check(this, DARAppShell);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "handleLink", function(param) {
            var event = param.event, url = param.url;
            var ref = doesMatchRoute(url), routeMatch = ref.routeMatch, relativeURL = ref.relativeURL;
            if (routeMatch) {
                event.preventDefault();
                Router.push(relativeURL);
                // Analytics: Remove Guest applied filters when navigating via megaNav (within CDPs / SeRP)
                clearAppliedFilter();
            }
        });
        if (process.browser) {
            var _sentry = publicConfig.sentry, enabled = _sentry.enabled, dsn = _sentry.dsn;
            if (enabled && dsn) {
                var mxLoggers = [
                    "cdp-app",
                    "e-com-web-app",
                    "pdp-app",
                    "error-app",
                    "gift-card-app",
                    "footwear-app",
                    "story-app",
                    "search-app",
                    "recommendations-app",
                    "mwa-ab-testing",
                    "mwa-personalization",
                    "product-ed-app",
                    "size-guide-app",
                    "outfitting-app",
                    "peps-remote-components",
                    "abt-remote-components",
                    "login-app",
                    "login-v2",
                    "pdp-reviews-app",
                    "loyalty-app",
                    "navigation-app",
                    "saved-items-app", 
                ];
                initSentry(_object_spread_props(_object_spread({}, publicConfig.sentry), {
                    release: process.env.GIT_SHA,
                    beforeSendTransaction: beforeSendTransaction,
                    transport: makeMultiplexedTransport(makeFetchTransport, multiplexerRouter(mxLoggers.reduce(function(prev, curr) {
                        var ref, ref1;
                        return _object_spread_props(_object_spread({}, prev), _define_property({}, curr, ((ref = publicConfig.sentry) === null || ref === void 0 ? void 0 : (ref1 = ref.remotes) === null || ref1 === void 0 ? void 0 : ref1[curr]) || dsn));
                    }, {}), dsn)),
                    integrations: [
                        new BrowserTracing({
                            beforeNavigate: function(context) {
                                return _object_spread_props(_object_spread({}, context), {
                                    name: sanitizeTransactionName(location === null || location === void 0 ? void 0 : location.pathname)
                                });
                            }
                        }), 
                    ]
                }));
            }
            try {
                if (process.browser) {
                    var urlSearchParams = new URLSearchParams(window.location.search);
                    var params = Object.fromEntries(urlSearchParams.entries());
                    if (params === null || params === void 0 ? void 0 : params.perf) {
                        window.withPerf = true;
                    }
                }
            } catch (e) {
                log.error("Could not parse URL for locale and sl");
            }
            // Set local country/language
            digitalData.setGlobalData({
                country: Cookies.get("Country") || "",
                geoRegion: Cookies.get("sl") || ""
            });
            digitalData.setUserData({
                activeMember: String(Cookies.get("membership")) === "true",
                userState: isUserLoggedIn() ? "authenticated" : "guest"
            });
            // External scripts currently rely on this global
            window.store = props.reduxStore;
            // Create trigger for Oracle Engagement Engine to re-evaluate based on variable change
            window.triggerOEEUpdate = 0;
        }
        return _this;
    }
    _create_class(DARAppShell, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var reduxStore = this.props.reduxStore;
                if (window.performance && window.performance.mark) {
                    window.performance.mark("DARAppMount");
                }
                // Fetch remote digital data if necessary
                loadDigitalData(publicConfig.apiHost).then(function(data) {
                    reduxStore.dispatch(analyticsDataLayerLoaded(data));
                });
                // Apply flags to redux store
                setGlobalFlagAPI(reduxStore);
                setHydrated(true);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, children = _props.children, navState = _props.navState, locale = _props.locale;
                return /*#__PURE__*/ _jsx(ABFlagsProvider, {
                    children: /*#__PURE__*/ _jsx(EcomWebAppJotaiProvider, {
                        children: /*#__PURE__*/ _jsx(NavDataProvider, {
                            navData: navState,
                            children: /*#__PURE__*/ _jsx(AnalyticsProvider, {
                                children: /*#__PURE__*/ _jsx(ToastProvider, {
                                    children: /*#__PURE__*/ _jsx(ToastProviderV6, {
                                        children: /*#__PURE__*/ _jsx(Layout, {
                                            locale: locale,
                                            children: children
                                        })
                                    })
                                })
                            })
                        })
                    })
                });
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(param) {
                var ctx = param.ctx, router = param.router;
                return _async_to_generator(regeneratorRuntime.mark(function _callee() {
                    var redirectHandler, promises, ref, pageProps, navState, nextDirBuildPath;
                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                // Handle redirect errors from page level getInitialProps
                                redirectHandler = function _redirectHandler(err) {
                                    // Rethrow if it's not a redirect
                                    if (!err.isRedirect) throw err;
                                    // Already on error page
                                    if (router.pathname.indexOf("error") !== -1) throw err;
                                    // Merge destination query params with current query params
                                    var _query = router.query, wildcard = _query.wildcard, rest = _object_without_properties(_query, [
                                        "wildcard"
                                    ]);
                                    var parsed = url.parse(err.url);
                                    parsed.search = mergeQueryParams(qs.parse(parsed.search), rest);
                                    var redirectUrl = url.format(parsed);
                                    // Redirect
                                    if (!process.browser) {
                                        // Enforce absolute URL in deployed envs
                                        if ("production" !== "development" && !redirectUrl.startsWith("http")) {
                                            redirectUrl = "".concat(publicConfig.apiHost).concat(redirectUrl);
                                        }
                                        ctx.res.writeHead(302, {
                                            Location: redirectUrl
                                        });
                                        ctx.res.end();
                                    } else {
                                        router.push(redirectUrl);
                                    }
                                };
                                ;
                                promises = [];
                                // Fetch page's initial props
                                promises[0] = Promise.resolve({});
                                // Component.getInitialProps
                                //   ? Component.getInitialProps({ ctx, router }).catch(redirectHandler)
                                //   : Promise.resolve({});
                                if (!process.browser) {
                                    // Fetch localized nav & footer when cookies are still being updated
                                    // Only fetch nav data during initial SSR render.
                                    promises[1] = NavDataProvider.loadData({
                                        requestUrl: ctx.req.url,
                                        navConfig: {
                                            personalizedSSR: true,
                                            multipleFooters: true,
                                            links: publicConfig.links,
                                            apiHost: publicConfig.apiHost,
                                            apiHostBasePath: publicConfig.apiHostBasePath
                                        },
                                        locale: convertToDashed(ctx === null || ctx === void 0 ? void 0 : ctx.nextLocale),
                                        contentfulConfig: publicConfig.contentful.navigation
                                    });
                                } else {
                                    // Otherwise, we'll always have it cached here.
                                    promises[1] = Promise.resolve(// eslint-disable-next-line no-underscore-dangle
                                    window.__NEXT_DATA__.props.layoutProps.navState);
                                }
                                _ctx.t0 = _sliced_to_array;
                                _ctx.next = 8;
                                return Promise.all(promises).catch(redirectHandler);
                            case 8:
                                _ctx.t1 = _ctx.sent;
                                ref = (0, _ctx.t0)(_ctx.t1, 2);
                                pageProps = ref[0];
                                navState = ref[1];
                                nextDirBuildPath = process.env.AWS_EXECUTION_ENV // AWS_EXECUTION_ENV is valid at lambda runtime
                                 ? // we need to get to "/var/task/packages/ecom-site/"
                                "".concat(__dirname, '"/../../../') : "/";
                                return _ctx.abrupt("return", {
                                    pageProps: pageProps,
                                    navState: navState,
                                    knownRoutes: getRouteManifest([], nextDirBuildPath),
                                    urqlFetchOptions: ctx ? ctx.urqlFetchOptions : {},
                                    locale: (ctx === null || ctx === void 0 ? void 0 : ctx.nextLocale) ? convertToUnderscored(ctx.nextLocale) : ""
                                });
                            case 14:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        }
    ]);
    return DARAppShell;
}(_Component = React.Component);
_define_property(DARAppShell, "propTypes", {
    Component: PropTypes.elementType,
    navState: PropTypes.object,
    locale: PropTypes.string,
    pageProps: PropTypes.object,
    reduxStore: PropTypes.object,
    urqlClient: PropTypes.object,
    urqlFetchOptions: PropTypes.object
});
var ComposedLayout = compose(withHydrationOverlay, withDigitalData, withCommitHash, withLapel(), withWeather(), withReduxStore, withCdpSeoDataService, withLocale, withHeaderFlags({
    transPerfectHeader: "x-globallinkweb-wolf"
}), withUrqlClient, withWrappedFetch, withDeviceCharacteristics, withLaunchDarkly)(DARAppShell);
function withDARApp(Page) {
    Page.Layout = ComposedLayout; // eslint-disable-line
    return Page;
}
export default withDARApp;
